import type { HTMLAttributes, ReactNode } from "react";

export type CardTone = "content" | "surface" | "verdict" | "action" | "info";

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  tone?: CardTone;
  children: ReactNode;
}

const toneClass: Record<CardTone, string> = {
  content: "card-content",
  surface: "card-surface",
  verdict: "card-verdict on-sage",
  action: "card-action",
  info: "card-info",
};

export function Card({ tone = "content", className, children, ...rest }: CardProps) {
  return (
    <div className={["card", toneClass[tone], className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </div>
  );
}
